export const ComparedIcon = ({ className = '' }) => {
  return (
    <svg
      className={`${className}`}
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.84618 5.9271C4.69566 5.92753 4.54834 5.97055 4.42126 6.05121C4.29417 6.13187 4.19252 6.24686 4.12806 6.38288C4.0636 6.51889 4.03897 6.67038 4.05702 6.81982C4.07507 6.96925 4.13505 7.11052 4.23004 7.22728L6.25489 9.70772C6.32708 9.79737 6.41963 9.86849 6.52483 9.91519C6.63004 9.96189 6.74486 9.98281 6.85978 9.97622C7.10555 9.96302 7.32744 9.83155 7.46891 9.61538L11.675 2.84141C11.6757 2.84028 11.6765 2.83916 11.6772 2.83805C11.7167 2.77745 11.7039 2.65737 11.6224 2.58193C11.6 2.56121 11.5736 2.5453 11.5449 2.53516C11.5161 2.52503 11.4856 2.52089 11.4552 2.523C11.4247 2.52511 11.3951 2.53342 11.368 2.54743C11.3409 2.56144 11.317 2.58085 11.2977 2.60445C11.2962 2.60631 11.2946 2.60814 11.293 2.60994L7.05106 7.4027C7.03492 7.42094 7.01532 7.43579 6.99339 7.44638C6.97146 7.45698 6.94764 7.46312 6.92332 7.46443C6.899 7.46575 6.87467 7.46222 6.85172 7.45405C6.82878 7.44588 6.80769 7.43323 6.78967 7.41684L5.38185 6.13571C5.23564 6.00168 5.04453 5.92726 4.84618 5.9271Z'
        fill='#1E42C0'
      />
      <circle cx='7.125' cy='7.125' r='5.875' stroke='#1E42C0' />
    </svg>
  )
}
